
/**
 * Truncate a text based on the number of characters
 * @param {String} text 
 * @param {Number} num 
 */
export function ellipsis(text = '', num = 50) {
  const index = text.indexOf('[more]');

  if (index > -1) {
    return text.substring(0, index);
  }

  return text.length > num
    ? `${text.substring(0, num)}...`
    : text;
}

/**
 * Removes html tags from the given string
 */
export function removeHtml(value) {
  const result = String(value).replace('&nbsp;', ' ');

  return result ? String(result).replace(/<[^>]+>/gm, ' ') : '';
}
